import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import get from 'lodash/get'

const AccountVerificationBanner = () => {
  const { pathname } = useLocation()
  const currentUser = useSelector(({ auth }) => auth.currentUser)
  const pathMatches = pathname.match(/\/my\/(listings|inbox)/)
  const verificationStatus = get(
    currentUser,
    'payout_account.verification_status',
  )
  const shouldShow = pathMatches && verificationStatus === 'unverified'
  if (!shouldShow) return null
  return (
    <div className="alerts-wrapper">
      <div className="container-flexible alerts alert-warning">
        <div className="row">
          <div className="col-md-12 alert alert-dismissible" role="alert">
            <span>
              Stripe requires additional information to verify your payout
              account.{' '}
              <a href="/my/account/payout-account">Verify your account now.</a>
            </span>
            <button
              className="close"
              aria-label="Close"
              data-dismiss="alert"
              type="button"
            >
              <span className="icon icon-close" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountVerificationBanner
